import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, isDevMode, provideAppInitializer } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { environment } from '@env/environment';
import { jwtInterceptor, serverErrorInterceptor } from '@lib/interceptors';
import { appSessionReducer, appSessionStorageMetaReducer, hydrateAppSession } from '@lib/store';
import { storage } from '@lib/utils/storage/storage.utils';
import { provideStore, Store } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { routes } from './app.routes';

function appSessionInitializerFactory(store: Store) {
    return () => {
        const session = storage.getItem('appSession');
        if (session) {
            store.dispatch(hydrateAppSession({ session }));
        }
        return Promise.resolve();
    };
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withInterceptors([serverErrorInterceptor, jwtInterceptor])),
        provideStore({ appSession: appSessionStorageMetaReducer(appSessionReducer) }),
        ...(isDevMode() ? [provideStoreDevtools({ maxAge: 25, logOnly: true })] : []),
        {
            provide: provideAppInitializer,
            useFactory: appSessionInitializerFactory,
            deps: [Store],
            multi: true,
        },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.RECAPTCHA_SITE_KEY,
        },
    ],
};
